import { v4 as uuidv4 } from "uuid";
import config from "../../../components/helpers/socket/config";
import { send } from "../../../utils/sockets/asyncSocket";
import optionGridConfig from "./optionsGridConfig";
import { OrdersType } from "../../../Constants";

export function unsubscribeStrikeLadder(selectedOption) {
  if (selectedOption === undefined) return;
  let request = {
    action:
      optionGridConfig.socket.actions.CMED_OPTIONSGRID_UNSUBSCRIBE_STRIKELADDER,
    type: OrdersType.OPTIONS_GRID_GROUP,
    requestID: uuidv4(),
    payload: {
      termStructureCode: selectedOption.TermStructureCode,
    },
  };
  send(config.socket.channels.TRADING, request);
}
